import { render, staticRenderFns } from "./year_result_small.vue?vue&type=template&id=0c6d6ce3&"
import script from "./year_result_small.vue?vue&type=script&lang=js&"
export * from "./year_result_small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports